import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import HomePageBannerCardComponent from "./HomePageBannerCardComponent";

import "../../../styles/components/home/banner/homePageBannerComponent.scss";
import useWebsiteConfiguration from "../../../hooks/useWebsiteConfiguration";
import { websiteConfigurationEnum } from "../../../enums/websiteConfigurations/websiteConfigurationType.enum";

export const HomePageBannerComponent = () => {
  const banners = useWebsiteConfiguration(websiteConfigurationEnum.HomeBanner);

  // Ensure banners is an array
  const bannerList = Array.isArray(banners) ? banners : [];

  return (
    <div className="homePageBannerContainer">
      <Swiper
        className="swiperContainer"
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        modules={[Pagination, Autoplay]}
      >
        {bannerList.map((banner) => (
          <SwiperSlide key={banner.Id}>
            <HomePageBannerCardComponent props={{ image: banner.Url }} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomePageBannerComponent;
